import { render, staticRenderFns } from "./RateCardCreateSelectOffers.vue?vue&type=template&id=5c2a3aa6&scoped=true&"
import script from "./RateCardCreateSelectOffers.vue?vue&type=script&lang=ts&"
export * from "./RateCardCreateSelectOffers.vue?vue&type=script&lang=ts&"
import style0 from "./RateCardCreateSelectOffers.vue?vue&type=style&index=0&id=5c2a3aa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2a3aa6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCheckbox,VCol,VDataTable,VDialog,VForm,VRow,VSpacer,VTextField})
